<template>
  <div>
    <div class="co0">
      <div class="co1">
        <div class="co1-1">
          <button :class="'index-list-lefts-1 color'+ item.couponType">{{item.couponType == 1 ? '商品券' : '运费券'}}</button>
          <div class="price-box">
            <span :class="'co1-1-1 fot' + item.couponType">{{item.couponValue}}</span>
            <span :class="'co1-1-1-1 fot' + item.couponType">元</span>
          </div>
          <div :class="'co1-1-2 fot' + item.couponType">满{{item.minimumAmount}}元使用</div>
        </div>
        <div class="co1-2">
          <p class="name">{{item.name || '无优惠券名称'}}</p>
          <p class="time">{{item.beginTime && item.beginTime.split(' ')[0]}}~{{item.endTime && item.endTime.split(' ')[0]}}</p>

          <div :class="['btn-box', item.alreadyOwnedCount >= 1 ? 'have-box' : '']">
            <div v-if="item.canReceiveStatus == 1">
              <button
              :class="'btn btn-color' + item.couponType"
              v-if="item.alreadyOwnedCount == 0"
              @click="receiveCoupon(item)">立即领取</button>

              <button
              :class="'btn btn-color' + item.couponType"
              v-if="item.alreadyOwnedCount > 0"
              @click="receiveCoupon(item)">再领</button>
            </div>

            <div v-else-if="item.alreadyOwnedCount == 0">
              <button class="btn _disabled">已领完</button>
            </div>

            <button v-if="item.alreadyOwnedCount >= 1" class="have">持有{{item.alreadyOwnedCount}}张</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/utils/common";
import http from "@/utils/axios";
export default {
  name: "coupon-list-item",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
      required: true
    },
    pageCode:{
      default:'',
      type:[Number,String]
    }
  },
  data() {
    return {
      miniApp: false,
      typeFormat: ["cor-2", "cor-1"],
      frightListVisible: false,
      loading: true
    };
  },
  methods: {
    receiveCoupon(item) {
      this.$minicode.show({pageCode:this.pageCode,pageQueryParam:this.$route.query,isShow:'为了您有更好的体验，请您下载APP 或打开小程序'});
      http({
        url: "order/coupon/getCoupon",
        method: "post",
        parmes: {
          couponId: item.couponId,
          creator: "",
          modifier: ""
        }
      }).then(rps => {
        this.$toast("领取成功");
        this.$emit("callbaCoupon");
      });
    }
  },
  created() {
    // this.miniApp =
    //   navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
    //   "micromessenger";
  },
  computed: {}
};
</script>
<style lang="less" scoped>
button {
  outline: none;
  border: none;
}
.co0 {
  font-size: 20px;
  margin-bottom: 20px;
  .co1 {
    display: flex;
    background: #fff;
    height: 180px;
    border-radius: 10px;
    overflow: hidden;
    .co1-1 {
      position: relative;
      text-align: center;
      width: 280px;
      .price-box {
        margin-top: 46px;
      }
      .co1-1-1 {
        width: 130px;
        font-size: 48px;
        font-weight: 500;
      }
      .co1-1-1-1 {
        font-size: 24px;
        margin-left: 4px;
      }
      .co1-1-2 {
        font-size: 24px;
        font-weight: 500;
        margin-top: 4px;
      }
    }
    .index-list-lefts-1{
      position: absolute;
      width:91px;
      height:33px;
      border-radius:0px 100px 100px 0px;
      left: 0;
      top: 10px;
      font-size:20px;
      color: #fff;
    }
    .co1-2 {
      position: relative;
      padding-left: 11px;
      width: 450px;
      overflow: hidden;
      .name {
        margin-top: 30px;
        height: 80px;
        font-size: 28px;
        font-weight: bold;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .time {
        position: absolute;
        left: 11px;
        right: 0;
        bottom: 27px;
        z-index: 1;
        font-size: 20px;
        color: #666;
      }
      
      .btn-box {
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 2;
        font-size: 0;
        .btn {
          display: block;
          width: 140px;
          height: 46px;
          border-radius: 24px;
          color: #fff;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 20px;
          margin-right: 20px;
        }
        .btn-color1 {
          background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%);
        }
        .btn-color2 {
          background: linear-gradient(90deg, #FFC700 0%, #FF7E00 100%);
        }
        ._disabled {
          background: #F2F2F2;
          color: #999;
        }
      }
      
      .have-box {
        .btn {
          margin-bottom: 10px;
        }
      }
      .have {
        width: 160px;
        height: 46px;
        border-radius: 30px 0 0 0;
        background: #F2F2F2;
        color: #999;
        font-size: 24px;
      }
    }
  }
  .co2 {
    margin-top: -10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    padding: 24px 35px;
    color: #999999;
    li {
      margin-bottom: 10px;
    }
  }
}
.cor-1 {
  background: #fff;
}
.cor-2 {
  background: #cccccc;
}

.cor-4 {
  border: 2px solid #979797;
  color: #999999;
}
.cor-5 {
  background-color: #f9f9f9;
  color: #cccccc;
}
.color1{
  background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%); 
}
.color2{
  background-color: #F8A651;
}
.color3{
  background-color: #CCCCCC;
}
.fot1{
  color: #ED3939;
}
.fot2 {
  color: #F8A651;
}
.fot3 {
  color: #CCCCCC;
}


</style>
